module.exports = __webpack_public_path__ + "static/media/IMG-8.55e2fdb0.jpg";